module.exports = __webpack_public_path__ + "img/call@2x-100.f63ab7e1.jpg";